import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-psd-vertical',
  standalone: false,
  templateUrl: './psd-vertical.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class PsdVerticalComponent {
@Input() psdTest:any;
}
